import { h, Component } from 'preact';
import s from 'components/bolt/main/intro/intro.sss';
import { joinClasses } from 'utils/utils';
import tryToPlayVideo from 'utils/tryToPlayVideo';
import Store from 'store/store';

export default class Intro extends Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.$video;

		this.state = {
			clicked: false,
			showPrompt: false
		};

		this.onStarVideoCanPlay = this.onStarVideoCanPlay.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleStarClick = this.handleStarClick.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			this.setState({ showPrompt: true });
		}, 6000);
		
		Store.emit('CUSTOM_EVENT', {
			category: 'landing-page',
			action: 'page-view'
		});
	}

	onStarVideoCanPlay() {
		tryToPlayVideo(this.$video).catch();
		Store.emit('KEY_ASSET_LOADED', 'starVideo');
	}

	handleStarClick() {
		this.setState({ clicked: true });
		setTimeout(() => {
			this.handleClose();
		}, 1000);
		Store.emit('PLAY_SOUND', 'launchStar');
	}

	handleClose() {
		this.$video.pause();
		this.props.onClose();
	}

	render() {
		//Using placeholder assets
		const { imageRoot, videoRoot, isOpen, copy } = this.props;
		const { showPrompt, clicked } = this.state;

		return (
			<div class={joinClasses(s.container, isOpen && s.open)}>
				<div class={joinClasses(s.prompt, showPrompt && s.show)}><p>{copy.$intro.clickStar}</p><img src={`${imageRoot}/intro/yvvbgl.svg`} /><p>{copy.$intro.toEnter}</p></div>

				<button class={joinClasses(s.button, isOpen && s.open)} onClick={this.handleStarClick}>
					<video
						class={joinClasses(s.starVideo, clicked && s.clicked)}
						ref={video => this.$video = video}
						poster={`${imageRoot}/intro/fzzbgh.webp`}
						onCanPlay={this.onStarVideoCanPlay}
						autoplay
						loop
						muted
						playsinline
					>
						<source src={`${videoRoot}/intro/d4rcz8.mov`} type={'video/mp4; codecs="hvc1"'} />
						<source src={`${videoRoot}/intro/d4rcz8.webm`} type={'video/webm; codecs="vp9"'} />
					</video> 
				</button>

		
				<div class={joinClasses(s.overlay, clicked && s.clicked)} />
			</div>
		);
	}
}